import { simpleSet } from '@r/reducers/utils';

const setCalculationModeLegsOptions = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.legs.options;

export const options = setCalculationModeLegsOptions(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_LEGS_OPTIONS',
  []
);
